import { Dialog, Button, Flex } from "@radix-ui/themes";
import { Trans } from "@lingui/react";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { useSurveyStore } from "@store/survey";
import MarkdownDiv from "@components/MarkdownDiv";

export default function InfoDialog() {
  const surveySections = useSurveyStore((state) => state.surveySections);

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Button variant="ghost">
          <InfoCircledIcon />
          {surveySections?.settings?.info_button_text ? (
            surveySections?.settings.info_button_text
          ) : (
            <Trans id="InfoDialog.about">About</Trans>
          )}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content maxWidth="650px">
        <Dialog.Title>
          {surveySections?.settings?.title ? (
            surveySections?.settings.title
          ) : (
            <Trans id="InfoDialog.about">About</Trans>
          )}
        </Dialog.Title>
        <Dialog.Description></Dialog.Description>
        <MarkdownDiv markdown={surveySections?.description} />

        <Flex gap="3" mt="4" justify="end">
          <Dialog.Close>
            <Button variant="soft" color="gray">
              <Trans id="InfoDialog.close">Close</Trans>
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
